interface WizardStepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: readonly string[];
}

export function WizardStepIndicator({
  currentStep,
  totalSteps,
  stepLabels,
}: WizardStepIndicatorProps) {
  return (
    <div
      className="wizard-step-indicator d-flex align-items-center mb-4"
      style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}
    >
      {Array.from({ length: totalSteps }, (_, i) => {
        const stepNum = i + 1;
        const isCompleted = stepNum < currentStep;
        const isActive = stepNum === currentStep;
        const label = stepLabels[i] ?? `Step ${stepNum}`;

        return (
          <div
            key={stepNum}
            className="d-flex align-items-center"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <div
              className="d-flex flex-column align-items-center"
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              <div
                className={`wizard-step-circle rounded-circle d-flex align-items-center justify-content-center fw-bold${
                  isCompleted
                    ? ' bg-success text-white'
                    : isActive
                      ? ' bg-primary text-white'
                      : ' bg-light text-muted border'
                }`}
                style={{
                  width: 36,
                  height: 36,
                  fontSize: 14,
                  fontWeight: 'bold',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                // biome-ignore lint/a11y/useAriaPropsSupportedByRole: aria-current is a global ARIA state property valid on any element (Biome false-positive for role=generic)
                aria-current={isActive ? 'step' : undefined}
              >
                {isCompleted ? <span aria-label="completed">&#10003;</span> : stepNum}
              </div>
              <span
                className={`wizard-step-label mt-1 small${isActive ? ' fw-semibold text-primary' : isCompleted ? ' text-success' : ' text-muted'}`}
                style={{ fontSize: 11, whiteSpace: 'nowrap', marginTop: 4 }}
              >
                {label}
              </span>
            </div>
            {stepNum < totalSteps && (
              <div
                className={`wizard-step-connector mx-1 flex-grow-1${isCompleted ? ' bg-success' : ' bg-light border'}`}
                style={{ height: 2, minWidth: 24, margin: '0 4px', flexShrink: 0 }}
                aria-hidden="true"
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
